(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ariana-mega-menu').forEach((menu) => {
    menu.querySelectorAll('[data-mega-target]').forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-mega-target');
        menu.querySelectorAll('[data-mega-target]').forEach((item) => {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
        });
        menu.querySelectorAll('.ariana-mega-menu__pane').forEach((pane) => {
          pane.classList.toggle('is-active', pane.id === targetId);
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
